import type { Booking, Plan, PlanStop } from '@trippath/shared';
import { live } from '@trippath/shared';

import { iataOf } from './airports';
import type { Sector } from '../components/booking/TicketEditor';

/**
 * The stop a way's ticket is kept on and the ticket: the way's own, else, back through the
 * changes on the way, the first one before whose ticket goes on through them — one with a leg
 * for this way too, or with none said. A journey may start at a change: Tallinn's TLL → HEL →
 * CDG, Tallinn and Helsinki both changes, is Helsinki's way on to Paris too. With none, the
 * holder is where a ticket for it would be kept: its journey's start.
 */
export function ticketOf(
  plan: Plan,
  stop: PlanStop,
): { holder: PlanStop; ticket: Booking | undefined } {
  const at = plan.stops.indexOf(stop);
  const back = plan.stops.slice(0, at + 1).reverse();
  const reached = back.findIndex((one, before) => before > 0 && !back[before - 1]?.transfer);
  for (const [legs, holder] of back.slice(0, reached < 0 ? undefined : reached).entries()) {
    const ticket = holder.bookings.find(
      (booking) =>
        booking.kind === 'ticket' &&
        live(booking) &&
        (booking.legs.length === 0 || booking.legs.length > legs),
    );
    if (ticket) return { holder, ticket };
  }
  const start = stop.transfer
    ? plan.stops.slice(0, at).findLast((s) => !s.transfer)
    : undefined;
  return { holder: start ?? stop, ticket: undefined };
}

/** A flight's ends by their codes, `SYD` → `AUH`: the leg of its ticket a way is. */
export function sectorOf(stop: PlanStop): Sector | null {
  const out = stop.out;
  const origin = iataOf(out?.from?.name);
  const destination = iataOf(out?.to?.name);
  return origin && destination ? { origin, destination } : null;
}
